import React from "react";
import Header from '../header';

export default function Navbar(props) {
  return (
    <div className={""}>
        <Header hClass={props.hClass} />
    </div>
  ); 
}